/**
 * 表单校验小工具（用户端）。
 *
 * 为什么要跟后端保持同一份正则：前端拦下来是为了少一次「填完整张表才被退回」，
 * 但**判断标准必须一致** —— 前端放过去的、后端必须也放；后端拦下的、前端应该先拦。
 * 两边若不一致，用户会遇到「前端说没问题、提交却被拒」这种最难解释的情况。
 *
 * 后端对应位置：csmf-server 的 AuthController.register()
 *   if (!email.matches("^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$")) { ... }
 */

/**
 * 邮箱格式。
 *
 * 刻意**不去追求 RFC 5322** —— 那个正则长到没法维护，而且真正的验证手段是
 * 「能不能收到信」，而本平台没有邮件服务。这条只挡明显不对的：
 *   · 没有 @             → abc
 *   · @ 后面没有域名点    → abc@def
 *   · 中间有空格          → a b@c.com
 */
export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

/** 邮箱是否合法（会自动 trim） */
export function isEmail(v) {
  return EMAIL_RE.test(String(v == null ? '' : v).trim())
}

/**
 * 校验一个注册表单，返回第一条错误信息；全部通过返回空串。
 *
 * 抽成一个函数而不是散在组件里，是因为**弹窗版（LoginDialog）和独立页（Login）
 * 各有一份注册表单**，校验规则必须完全一样，否则两个入口会出现不同的行为。
 */
export function validateRegisterForm(f) {
  const email = String((f && f.email) || '').trim()
  if (!email) {
    return '請填寫信箱'
  }
  if (!isEmail(email)) {
    return '信箱格式不正確'
  }
  if (!f.password) {
    return '請填寫密碼'
  }
  if (String(f.password).length < 6) {
    return '密碼至少 6 位'
  }
  // 邀請碼必填 —— 這是邀請制的入口
  if (!String((f.inviteCode) || '').trim()) {
    return '請填寫邀請碼'
  }
  if (!f.captcha) {
    return '請輸入驗證碼'
  }
  return ''
}
